import { FormProvider } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { LoadingBackdrop } from '../../../components/_components';
import { useChangeEmail } from '../hooks/useChangeEmail';
import { ChangeEmailRequestModal } from '../components/ChangeEmailRequestModal';
import { VerifyOtpModal } from '../components/VerifyOtpModal';

type UserDetailsRootState = {
  userDetailsReducer?: {
    userDetails?: {
      email?: string;
    };
  };
};

export default function ChangeEmailPage() {
  const currentEmail = useSelector((state: UserDetailsRootState) => state.userDetailsReducer?.userDetails?.email ?? '');

  const {
    step,
    pendingEmail,
    oldEmail,
    secondsRemaining,
    requestForm,
    verifyForm,
    requestLoading,
    verifyLoading,
    resendLoading,
    resendCooldown,
    submitNewEmail,
    submitVerificationCode,
    resendOtp,
    goBackToRequestStep,
    cancel,
  } = useChangeEmail(currentEmail);

  const loading = step === 'request' ? requestLoading : verifyLoading;

  return (
    <>
      <LoadingBackdrop open={loading} />

      <FormProvider {...requestForm}>
        <ChangeEmailRequestModal
          open={step === 'request'}
          currentEmail={currentEmail}
          loading={requestLoading}
          onSubmit={(values) => void submitNewEmail(values)}
          onCancel={cancel}
        />
      </FormProvider>

      <FormProvider {...verifyForm}>
        <VerifyOtpModal
          open={step === 'verify'}
          oldEmail={oldEmail}
          newEmail={pendingEmail}
          loading={verifyLoading}
          secondsRemaining={secondsRemaining}
          resendLoading={resendLoading}
          resendCooldown={resendCooldown}
          onSubmit={(values) => void submitVerificationCode(values)}
          onResend={() => void resendOtp()}
          onEditEmail={goBackToRequestStep}
          onCancel={cancel}
        />
      </FormProvider>
    </>
  );
}
